import { useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { useAuth } from "../AuthContext";

const TILL_RETURN_PARAMS = ["tillStatus", "transId", "orderId", "ref", "isSaveCard"];

export const readTillReturn = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const tillStatus = params.get("tillStatus");
    if (!tillStatus) return null;
    return {
      tillStatus,
      transId: params.get("transId") || "",
      orderId: params.get("orderId") || "",
      orderRef: params.get("ref") || "",
      isSuccess: tillStatus === "success" || tillStatus === "successSave",
    };
  } catch (err) {
    return null;
  }
};

const stripTillParams = () => {
  try {
    const url = new URL(window.location.href);
    TILL_RETURN_PARAMS.forEach((key) => url.searchParams.delete(key));
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  } catch (err) {
    /* history unavailable */
  }
};

export const useTillReturnSettlement = () => {
  const [tillReturn] = useState(() => readTillReturn());
  const [settling, setSettling] = useState(() => tillReturn != null);
  const [settleFailed, setSettleFailed] = useState(false);
  const [checkoutState, setCheckoutState] = useState(null);
  const { userId } = useAuth();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!tillReturn || startedRef.current) return;
    startedRef.current = true;

    axiosInstance
      .post("Shipping/TillPaymentSuccess", {
        marchentid: tillReturn.transId,
        paystatus: tillReturn.tillStatus,
        userid: String(userId || ""),
        orderid: tillReturn.orderId,
        savecard: false,
      })
      .then((response) => {
        const raw = response && response.data ? response.data.checkoutState : null;
        if (!raw) return;
        try {
          const parsed = JSON.parse(raw);
          if (parsed && typeof parsed === "object") setCheckoutState(parsed);
        } catch (err) {
          /* unparseable state is treated as absent */
        }
      })
      .catch(() => setSettleFailed(true))
      .then(() => {
        stripTillParams();
        setSettling(false);
      });
  }, [tillReturn]);

  return { settling, settleFailed, tillReturn, checkoutState };
};
